import serviceAxios from "../index";
// 所有商圈
export const quan_getByDept = (params) => {
  return serviceAxios({
    url: "/app-api/jg/sheng-huo-quan/getByDept",
    method: "get",
    params,
  });
};
// 字典属性
export const dict_getDictData = (params) => {
  return serviceAxios({
    url: "/app-api/system/dict/getDictData",
    method: "get",
    params,
  });
};
// 业态分页
export const yeTai_page = (params) => {
  return serviceAxios({
    url: "/app-api/jg/yeTai/page",
    method: "get",
    params,
  });
};
// 获得订单交易分页
export const order_page = (params) => {
  return serviceAxios({
    url: "/report-api/trade/order/page",
    method: "get",
    params,
  });
};
// 获得线上交易数据
export const order_getMoney = (params) => {
  return serviceAxios({
    url: "/report-api/trade/order/getMoney",
    method: "get",
    params,
  });
};
// 获得商圈业态入驻数量排序
export const yeTai_getCountPx = (params) => {
  return serviceAxios({
    url: "/report-api/jg/yeTai/getCountPx",
    method: "get",
    params,
  });
};
// https://yinzuo.huigr.com/app-api/jg/yeTai/parkPage?pageNo=1&pageSize=50
// A1:获得停车场列分页
export const yeTai_parkPage = (params) => {
  return serviceAxios({
    url: "/app-api/jg/yeTai/parkPage",
    method: "get",
    params,
  });
};
// A2:查询停车库剩余车位数,参数parkIndexCode从parkPage接口获取
export const yeTai_remainSpaceNum = (params) => {
  return serviceAxios({
    url: '/app-api/jg/yeTai/remainSpaceNum',
    method: "get",
    params,
  });
};
// A3:获取客流统计组（商场集合）数据
export const yeTai_countGroup = (params) => {
  return serviceAxios({
    url: '/app-api/jg/yeTai/countGroup',
    method: "get",
    params,
  });
};
// A4:查询时间范围内的多个统计组的客流统计数据（商场集合）数据
export const yeTai_passengerFlow = (params) => {
  return serviceAxios({
    url: '/app-api/jg/yeTai/passengerFlow',
    method: "get",
    params,
  });
};
// 获得商圈入驻类型排序
export const yeTai_getYeTaiType = (params) => {
  return serviceAxios({
    url: "/report-api/jg/yeTai/getYeTaiType",
    method: "get",
    params,
  });
};
// 获得设备区域列表分页
export const hik_getRegions = (params) => {
  return serviceAxios({
    url: "/report-api/jg/hik/getRegions",
    method: "get",
    params,
  });
};
// 根据区域获取监控点列表
export const hik_cameraSearch = (params) => {
  return serviceAxios({
    url: "/report-api/jg/hik/cameraSearch",
    method: "get",
    params,
  });
};
// 获取监控点预览取流URL
export const hik_camerasPreviewURLs = (params) => {
  return serviceAxios({
    url: "/report-api/jg/hik/camerasPreviewURLs",
    method: "get",
    params,
  });
};

// 根据条件获取监控点在线状态接口 status状态，1-在线，0-离线，-1-未检测
export const hik_status = (params) => {
  return serviceAxios({
    url: "/report-api/jg/hik/status",
    method: "get",
    params,
  });
};
// export const login = (data) => {
//   return serviceAxios({
//     url: "/api/user/login",
//     method: "post",
//     data,
//   });
// };